const SineGlitchShader = {

	name: 'SineGlitchShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
		'time': { type: 'f', value: 0.002}
        

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

		uniform float time;

		varying vec2 vUv;

        vec2 uv;

        float speed1 = 0.3;
        float spread1 = 80.0;
        float power1 = 0.002;

        float speed2 = 0.5;
        float spread2 = 150.0;
        float power2 = 0.003;

          void texelCoord()
        {
          float y1 = (vUv.y + time * speed1) * spread1;
          float y2 = (vUv.y + time * speed2) * spread2;
          uv = vUv;
          uv.x += (sin(y1) * power1 * sin(time * 2.0)) + (sin(y2) * power2 * sin(time * 5.0));
        }

		void main() {

			texelCoord();
			vec4 texel = texture2D( tDiffuse, vec2(uv.x, uv.y) );
   
			gl_FragColor = texel * opacity;
   ;
		}`

};

